import { _ as t } from "../internals/export.js";
import { a as r } from "../internals/an-object.js";
import { o } from "../internals/object-get-prototype-of.js";
import { c as e } from "../internals/correct-prototype-getter.js";
t({
  target: "Reflect",
  stat: !0,
  sham: !e
}, {
  getPrototypeOf: function getPrototypeOf(t) {
    return o(r(t));
  }
});